import { withStaticProperties } from '@fhs/utils';

import { AnchorListHorizontal } from './anchor-list-horizontal';
import { AnchorListVertical } from './anchor-list-vertical';
import { AnchorSectionList as AnchorSectionList_ } from './anchor-section-list';
import { SectionList } from './section-list';

export { NonSemanticFlashListCell } from './non-semantic-flash-list-cell';

export const AnchorSectionList = withStaticProperties(AnchorSectionList_, {
  SectionList,
  AnchorListHorizontal,
  AnchorListVertical,
});
